import request from '@/utils/request';

// 记录访问 - 超轻量化版本
export function wenVisit(data = {}) {
  const visitData = {
    page: data.page || window.location.pathname,
    screenWidth: window.screen?.width || 0,
    screenHeight: window.screen?.height || 0,
    userAgent: window.navigator.userAgent,
    title: data.title || document.title,
    from: data.from || document.referrer,
    ...data
  };

  // 使用极短超时，避免阻塞
  return request({
    url: '/api/visit/wen',
    method: 'post',
    data: visitData,
    timeout: 1500 // 1.5秒超时
  }).catch(error => {
    // 静默处理错误，不影响用户体验
    return { success: false, message: 'timeout' };
  });
}

// 获取访问统计 - 添加缓存支持
export function getVisitStats() {
  return request({
    url: '/api/visit/stats',
    method: 'get',
    timeout: 5000 // 5秒超时
  }).catch(error => {
    console.error('获取访问统计失败:', error);
    return { success: false, message: 'stats_error' };
  });
}

// 获取来源类型
function getReferrerType(referrer) {
  if (!referrer) return 'direct';

  const searchEngines = ['google', 'bing', 'baidu', 'yahoo'];
  const socialPlatforms = ['facebook', 'twitter', 'instagram', 'linkedin'];

  const domain = new URL(referrer).hostname.toLowerCase();

  if (searchEngines.some(se => domain.includes(se))) return 'search';
  if (socialPlatforms.some(sp => domain.includes(sp))) return 'social';

  return 'other';
}


